// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const ADD_PROGRESS_NOTE_LOADING = 'ADD_PROGRESS_NOTE_LOADING';
export const ADD_PROGRESS_NOTE_SUCCESS = 'ADD_PROGRESS_NOTE_SUCCESS';
export const ADD_PROGRESS_NOTE_ERROR = 'ADD_PROGRESS_NOTE_ERROR';
export const UPDATE_PROGRESS_NOTE_LOADING = 'UPDATE_PROGRESS_NOTE_LOADING';
export const UPDATE_PROGRESS_NOTE_SUCCESS = 'UPDATE_PROGRESS_NOTE_SUCCESS';
export const UPDATE_PROGRESS_NOTE_ERROR = 'UPDATE_PROGRESS_NOTE_ERROR';
export const DELETE_PROGRESS_NOTE_LOADING = 'DELETE_PROGRESS_NOTE_LOADING';
export const DELETE_PROGRESS_NOTE_SUCCESS = 'DELETE_PROGRESS_NOTE_SUCCESS';
export const DELETE_PROGRESS_NOTE_ERROR = 'DELETE_PROGRESS_NOTE_ERROR';

function addProgressNote(patientId: string, progressNote: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/progressNote/add${type}`,
      {
        ...progressNote,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_PROGRESS_NOTE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_PROGRESS_NOTE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_PROGRESS_NOTE_LOADING,
    });
  });
}

function updateProgressNote(patientId: string, progressNote: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/progressNote/update${type}`,
      {
        ...progressNote,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_PROGRESS_NOTE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_PROGRESS_NOTE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_PROGRESS_NOTE_LOADING,
    });
  });
}

function deleteProgressNote(patientId: string, progressNoteId: string, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/progressNote/delete${type}`,
      {
        progressNoteId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_PROGRESS_NOTE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_PROGRESS_NOTE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_PROGRESS_NOTE_LOADING,
    });
  });
}

export function addVitalSign(patientId: string, progressNote: Object) {
  return addProgressNote(patientId, progressNote, 'VitalSign');
}
export function updateVitalSign(patientId: string, progressNote: Object) {
  return updateProgressNote(patientId, progressNote, 'VitalSign');
}
export function deleteVitalSign(patientId: string, progressNoteId: string) {
  return deleteProgressNote(patientId, progressNoteId, 'VitalSign');
}
export function addNurseNote(patientId: string, progressNote: Object) {
  return addProgressNote(patientId, progressNote, 'NurseNote');
}
export function updateNurseNote(patientId: string, progressNote: Object) {
  return updateProgressNote(patientId, progressNote, 'NurseNote');
}
export function deleteNurseNote(patientId: string, progressNoteId: string) {
  return deleteProgressNote(patientId, progressNoteId, 'NurseNote');
}
export function addProviderNote(patientId: string, progressNote: Object) {
  return addProgressNote(patientId, progressNote, 'ProviderNote');
}
export function updateProviderNote(patientId: string, progressNote: Object) {
  return updateProgressNote(patientId, progressNote, 'ProviderNote');
}
export function deleteProviderNote(patientId: string, progressNoteId: string) {
  return deleteProgressNote(patientId, progressNoteId, 'ProviderNote');
}
export function addSymptomAnalysis(patientId: string, progressNote: Object) {
  return addProgressNote(patientId, progressNote, 'SymptomAnalysis');
}
export function updateSymptomAnalysis(patientId: string, progressNote: Object) {
  return updateProgressNote(patientId, progressNote, 'SymptomAnalysis');
}
export function deleteSymptomAnalysis(patientId: string, progressNoteId: string) {
  return deleteProgressNote(patientId, progressNoteId, 'SymptomAnalysis');
}
export function addSystemAssessment(patientId: string, progressNote: Object) {
  return addProgressNote(patientId, progressNote, 'SystemAssessment');
}
export function updateSystemAssessment(patientId: string, progressNote: Object) {
  return updateProgressNote(patientId, progressNote, 'SystemAssessment');
}
export function deleteSystemAssessment(patientId: string, progressNoteId: string) {
  return deleteProgressNote(patientId, progressNoteId, 'SystemAssessment');
}



// WEBPACK FOOTER //
// ./client/src/actions/progressNoteActions.js